import { logd } from '../../utils/utils';
import {
  AnalyticsData,
  EventName,
  PianoAnalyticsEventData,
} from './piano-analytics.types';
import {
  browserId,
  calculateAdditionalData,
  getPageName,
  userAgentData,
} from './piano-analytics.utils';

const site = '636138';

class PianoAnalyticsService {
  private readonly apiUrl: string;
  private readonly baseUrl =
    location.hostname === 'localhost'
      ? `${location.origin}/api/msp/log-endpoint`
      : 'https://da.rabobank.nl/event';

  constructor() {
    const params = new URLSearchParams();
    params.append('s', site);
    params.append('idclient', browserId);
    this.apiUrl = `${this.baseUrl}?${params.toString()}`;
  }

  public async sendFetch(data: string): Promise<void> {
    const response = await fetch(this.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain',
      },
      body: data,
    });
    if (!response.ok) {
      throw new Error(`HTTP error. Status: ${response.status}`);
    }
    const responseData = (await response.json()) as unknown;
    logd(() => {
      console.log('Event sent successfully:', responseData);
    });
  }

  async sendEvent(eventData: {
    events: { name: EventName; data: PianoAnalyticsEventData }[];
  }): Promise<void> {
    try {
      const data = JSON.stringify(eventData);

      const beaconSent = navigator.sendBeacon(this.apiUrl, data);
      if (beaconSent) {
        logd(() => {
          console.log('Event sent successfully using sendBeacon');
        });
      } else {
        logd(() => {
          console.error('Failed to send event using sendBeacon');
        });
        await this.sendFetch(data);
      }
    } catch (error) {
      console.error('Error sending event:', error);
    }
  }
}

export const pianoAnalyticsService = new PianoAnalyticsService();

export async function sendEvent(
  name: EventName,
  event: AnalyticsData,
): Promise<void> {
  try {
    const additionalData = calculateAdditionalData();
    const userAgent = await userAgentData();
    const eventData = {
      events: [
        {
          name,
          data: {
            page: getPageName(event),
            ...additionalData,
            ...userAgent,
            ...event,
          } as PianoAnalyticsEventData,
        },
      ],
    };
    await pianoAnalyticsService.sendEvent(eventData);
  } catch (error) {
    console.error('Error sending event:', error);
  }
}
